import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import { azure, black, screenSmMin, screenMdMin } from '@spotify-internal/encore-foundation';
import { useLocalePreferenceContext } from '../../hooks/useLocalePreference';

export function Video() {
  const [showVideoPlayer, setShowVideoPlayer] = useState(false);
  const localePreference = useLocalePreferenceContext();

  return (
    <VideoContainer>
      <div style={{ display: 'inline-block', position: 'relative', lineHeight: 1 }}>
        {showVideoPlayer ? (
          <VideoIframe
            data-testid="landing-page--video-player"
            src={`${localePreference.brandVideoUrl}?autoplay=1&iv_load_policy=3&playsinline=1&rel=0&modestbranding=1`}
            frameBorder="0"
            allowFullScreen
            allow="autoplay; encrypted-media"
          />
        ) : (
          <VideoThumbnail
            data-testid="landing-page--video-thumbnail"
            onClick={() => {
              setShowVideoPlayer(true);
            }}
          >
            <VideoImg
              src="/images/landing_page/img-video-preview.png"
              alt="Spotify for Podcasters - Stream on"
            />
          </VideoThumbnail>
        )}
      </div>
    </VideoContainer>
  );
}

const videoHorizontalPadding = 16;

const VideoContainer = styled.div`
  text-align: center;
  padding: 70px ${videoHorizontalPadding}px;

  @media (min-width: ${screenMdMin}) {
    padding: 90px 0 76px;
  }
`;

const videoWidth = 984;
const videoHeight = 554;
const videoDimensions = css`
  /* preserve the 16:9 aspect ratio */
  width: calc(100vw - ${videoHorizontalPadding * 2}px);
  height: calc((100vw - ${videoHorizontalPadding * 2}px) * ${videoHeight} / ${videoWidth});
  min-width: 343px;
  min-height: 193px;

  @media (min-width: ${screenMdMin}) {
    width: ${videoWidth}px;
    height: ${videoHeight}px;
  }
`;

const VideoIframe = styled.iframe`
  position: relative;
  margin: auto;
  display: inline-block;
  background-color: ${black};

  ${videoDimensions}
`;

const VideoThumbnail = styled.div`
  display: inline-block;
  position: relative;
  cursor: pointer;

  &::before {
    background-image: url('data:image/svg+xml;charset=utf-8,%3Csvg%20width%3D%22107%22%20height%3D%22107%22%20viewBox%3D%220%200%20107%20107%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Ccircle%20cx%3D%2253.5%22%20cy%3D%2253.5%22%20r%3D%2253.5%22%20fill%3D%22%23509BF5%22%2F%3E%0A%3Cpath%20d%3D%22M75.9922%2054.108L43.1626%2073.0622L43.1626%2035.1539L75.9922%2054.108Z%22%20fill%3D%22white%22%2F%3E%0A%3C%2Fsvg%3E');
    background-size: cover;
    content: '';
    display: block;
    height: 57px;
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    transition: opacity 0.3s;
    width: 57px;
    z-index: 1;
    pointer-events: none;
  }

  @media (min-width: ${screenSmMin}) {
    &::before {
      height: 71px;
      opacity: 0;
      width: 71px;
    }

    &:hover::before {
      opacity: 1;
    }
  }
`;

const VideoImg = styled.img`
  ${videoDimensions}
`;
